import { configureStore } from '@reduxjs/toolkit';
import sessionReducer from './sessionSlice';
import authReducer from './authSlice';
import appReducer from './appSlice';
import posCustomerReducer from './posCustomerSlice';
import identityReducer from './identitySlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    app: appReducer,
    posCustomer: posCustomerReducer,
    identity: identityReducer,
    session: sessionReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
